<div fxFlex fxLayoutAlign="space-around" class="footer">      
  <span style="margin-right: auto"></span>
  <span>Copyright © 2020 <a [routerLink]="['/monitors']">Resus</a></span>
</div>